import { connect } from 'react-redux';

import {
  actionCreateLandmark,
  actionDeleteLandmark,
  actionGetLandmarkDetails,
  actionUpdateLandmark,
} from 'store/landmark/action';
import { actionGetMarketList } from 'store/market/actions';
import ManagerAreas from './ManagerAreas';

const mapStateToProps = (state) => ({
  marketList: state.Market.marketList,
  isLoadingMarketList: state.Market.isLoadingMarketList,
  isLoadingCreateLandmark: state.Landmark.isLoadingCreateLandmark,
  isLoadingDeleteLandmark: state.Landmark.isLoadingDeleteLandmark,
  isLoadingLandmarkDetails: state.Landmark.isLoadingLandmarkDetails,
  isLoadingUpdateLandmark: state.Landmark.isLoadingUpdateLandmark,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetMarketList: (payload) => dispatch(actionGetMarketList(payload)),
  actionCreateLandmark: (payload) => dispatch(actionCreateLandmark(payload)),
  actionGetLandmarkDetails: (payload) => dispatch(actionGetLandmarkDetails(payload)),
  actionUpdateLandmark: (payload) => dispatch(actionUpdateLandmark(payload)),
  actionDeleteLandmark: (payload) => dispatch(actionDeleteLandmark(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerAreas);
